<template>
  <div class="volume-control">
    <button
      class="control-button volume-button"
      @click="emit('toggleMute')"
      :aria-label="isMuted ? t('player.controls.unmute') : t('player.controls.mute')"
      :data-tooltip="(isMuted ? t('player.controls.unmute') : t('player.controls.mute')) + ' (m)'"
      v-html="currentIcon"
    />
    <div class="volume-slider-container">
      <input
        type="range"
        class="volume-slider"
        min="0"
        max="100"
        :value="volumePercent"
        @input="onSliderInput"
        :aria-label="t('player.controls.volume')"
        :aria-valuenow="volumePercent"
        :aria-valuemin="0"
        :aria-valuemax="100"
        :aria-valuetext="`${volumePercent}%`"
        :style="{ '--volume-percentage': `${volumePercent}%` }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { volumeHighIcon, volumeLowIcon, volumeMuteIcon } from '../../assets/icons'
import { useVideoI18n } from '../../i18n'

const props = defineProps<{
  volume: number
  isMuted: boolean
}>()

const emit = defineEmits<{
  volumeChange: [vol: number]
  toggleMute: []
}>()

const { t } = useVideoI18n()

const volumePercent = computed(() => {
  if (props.isMuted) return 0
  return Math.round(props.volume * 100)
})

const currentIcon = computed(() => {
  if (props.isMuted || props.volume === 0) return volumeMuteIcon
  if (props.volume < 0.5) return volumeLowIcon
  return volumeHighIcon
})

function onSliderInput(event: Event): void {
  const target = event.target as HTMLInputElement
  emit('volumeChange', parseInt(target.value) / 100)
}
</script>

<style scoped lang="scss">
/* Main styles in _volume-control.scss — only responsive override here */
@media (max-width: 768px) {
  .volume-slider-container {
    display: none;
  }
}
</style>
